import { useEffect } from 'react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_0873b6a5-4361-426a-a8a4-b14247528402/artifacts/elxc3zgj_delite%20logo%20wa.jpeg';
const HERO_IMG = 'https://customer-assets.emergentagent.com/job_0873b6a5-4361-426a-a8a4-b14247528402/artifacts/y5cbki0g_CAR%20RESCUE.png';
const AMARON_LOGO = 'https://customer-assets.emergentagent.com/job_0873b6a5-4361-426a-a8a4-b14247528402/artifacts/bon05h6e_product-jpeg.jpg';
const EXIDE_LOGO = 'https://customer-assets.emergentagent.com/job_0873b6a5-4361-426a-a8a4-b14247528402/artifacts/4x4lqhdt_164762.svg';
const SF_LOGO = 'https://customer-assets.emergentagent.com/job_0873b6a5-4361-426a-a8a4-b14247528402/artifacts/p946dgxf_ZU8eoWBt_400x400.jpg';

const Rescue = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white px-5 py-5 sm:px-8 max-w-lg mx-auto" data-testid="rescue-page">
      {/* Logo */}
      <a href="https://www.deliteautolec.in" target="_blank" rel="noopener noreferrer" className="inline-block mb-4" data-testid="rescue-logo-link">
        <img src={LOGO_URL} alt="DELITE" className="h-11 sm:h-14 object-contain" data-testid="rescue-logo" />
        <p className="text-xs text-gray-500 italic mt-0.5">Serving Vijayawada since 1990.</p>
      </a>

      {/* H1 Headline */}
      <h1
        className="text-2xl sm:text-3xl font-extrabold text-gray-900 leading-tight tracking-tight mb-3 text-center"
        data-testid="rescue-headline"
      >
        Dead Car Battery?<br />We'll Replace It in 60&nbsp;Minutes.
      </h1>

      {/* Brand Logos */}
      <div className="flex items-center justify-center gap-5 mb-3" data-testid="brand-logos">
        <img src={AMARON_LOGO} alt="Amaron" className="w-20 h-10 object-contain" />
        <img src={EXIDE_LOGO} alt="Exide" className="w-20 h-10 object-contain" />
        <img src={SF_LOGO} alt="SF Batteries" className="w-20 h-10 object-contain rounded-full" />
      </div>

      {/* Free Doorstep Installation - Bold */}
      <p className="text-base sm:text-lg font-bold text-gray-900 text-center mb-4">
        Free Doorstep Installation anywhere in Vijayawada.
      </p>

      {/* CTA Button */}
      <a
        href="https://wa.me/919347381519?text=Hi%20Delite,%20my%20car%20battery%20is%20dead.%20I%20need%20a%20replacement."
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full text-center text-white font-bold text-lg py-4 rounded-xl mb-5 transition-transform active:scale-95 hover:brightness-110 shadow-lg"
        style={{ backgroundColor: '#25D366' }}
        data-testid="rescue-cta-button"
      >
        WhatsApp for Free Price Quote &amp; Instant Support
      </a>

      {/* Hero Image */}
      <div className="mb-4" data-testid="rescue-hero-image">
        <img
          src={HERO_IMG}
          alt="DELITE — Professional battery replacement service"
          className="w-full rounded-xl shadow-lg"
          loading="eager"
        />
      </div>

      {/* Trust Markers */}
      <ul className="space-y-3 text-left text-gray-800 text-sm sm:text-base leading-relaxed" data-testid="rescue-trust-markers">
        <li>✅ <strong>Upfront Pricing:</strong> Know the exact price &amp; warranty on WhatsApp before you book.</li>
        <li>✅ <strong>Top Brands:</strong> Factory-fresh Exide, SF &amp; Amaron batteries.</li>
        <li>✅ <strong>Pay After Installation:</strong> No advance payment required.</li>
      </ul>
    </div>
  );
};

export default Rescue;
